import styled from 'styled-components';
import { ContainerSection } from '@/main/components/shared/styles';

export const Container = styled(ContainerSection)``;

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 1rem;
`;

export const HeaderText = styled.h4`
  color: #000;
  font-size: 1rem;
  font-weight: bold;
  margin: 0;
`;

export const RowInput = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: flex-start;
  gap: 10px;

  @media (max-width: 1367px) {
    grid-template-columns: 1fr 1fr;

    button {
      width: 100%;
      max-width: 100%;
      padding: 0.4rem 0 !important;
      margin: 0;
    }
  }

  @media (max-width: 730px) {
    grid-template-columns: 1fr;

    button {
      width: 100%;
      max-width: 100%;
      padding: 0.4rem 0 !important;
      margin: 0;
    }
  }
`;

export const ContainerObservation = styled.div`
  margin-top: 10px;
`;

export const ContainerDragDrop = styled.div`
  width: 100%;
  margin-top: 10px;
`;

export const AreaInputNumber = styled.div`
  position: relative;
`;

export const AreaCheckbox = styled.div`
  position: absolute;
  top: 14px;
  right: .6rem;
  margin: 0;

  .MuiFormControlLabel-root{
    margin:0;
  }

  .MuiCheckbox-root{
    padding: 0;
  }

  .MuiCheckbox-colorSecondary.Mui-checked{
    color: #fab01c;
  }
`;